import { createEnumParam, useQueryParam, withDefault } from 'use-query-params';

export enum EBulkMode {
  NONE = 'NONE',
  BULK_WEBSITE = 'BULK_WEBSITE',
}

export const QR_CODE_BULK_MODE_QUERY_PARAM = 'bulkMode';

const BulkEnumParam = createEnumParam(Object.values(EBulkMode));

export const useBulkQueryParam = (defaultMode: EBulkMode) => {
  const [bulkMode = defaultMode, setBulkMode] = useQueryParam(
    QR_CODE_BULK_MODE_QUERY_PARAM,
    withDefault(BulkEnumParam, null)
  );

  return [bulkMode, setBulkMode] as const;
};
